import React from 'react';
import { Box, Typography, Button, Stack } from "@mui/material";
import BackgroundImage from '../assets/background.png';
import { useTranslation } from 'react-i18next';

import { paths } from 'routes';

import { IconWrapper } from 'components/Icon';
import { LocalizedLink } from 'website/components/LocalizedLink';


export const LoginSection = () => {
  const { t } = useTranslation();

  return (
    <Stack
      display={{ xs: 'none', md: 'flex' }}
      sx={{
        width: "100vw",
        marginLeft: { md: "-50vw" },
        left: { md: "50%" },
        flexDirection: 'column',
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        py: 8,
        boxSizing: "border-box",
        backgroundImage: `url(${BackgroundImage})`,
        backgroundPosition: 'center',
        backgroundSize: "cover",
        backgroundRepeat: 'no-repeat',
        mt: -7,
      }}
    >
      <Stack
        sx={{
          width: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          maxWidth: 1400,
          boxSizing: "border-box",
          px: { xs: 3, md: 6.25 },
        }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={1}
          alignItems={"center"}
        >
          <IconWrapper
            icon="login"
            sx={({palette}) => ({
              height: 102,
              width: 102,
              svg: {
                stroke: palette.background.primary,
                strokeWidth: 1.5,
                height: 102,
                width: 102,
                mt: -5.5,
              },
              ml: 1,
            })}
            height={14}
          />
          <Stack gap={2} ml={{xs: 0, md: 1.5}}>
            <Typography
              variant="h5"
              fontWeight="600"
              color='text.black'
              lineHeight={"normal"}
              fontSize={"1.5625rem"}
            >
              {t('website:homepage.loginSection.heading')}
            </Typography>
            <Typography
              variant="body4"
              color='#00000099'
            >
              {t('website:homepage.loginSection.description')}
            </Typography>
          </Stack>
        </Box>
        <Box
          sx={{
            '& > a, .MuiButton-root': {
              minWidth: 110,
              fontSize: '0.875rem',
              fontWeight: '500',
              color: '#fff',
              lineHeight: 1.75,
              display: 'flex',
              textDecoration: 'none',
              whiteSpace: 'nowrap',
            },
          }}
        >
          <LocalizedLink to={paths.auth.login}>
            <Button
              size="large"
              variant="contained"
              sx={{
                minWidth: 110,
                backgroundColor: 'primary.light',
                '&:hover': {
                  backgroundColor: 'primary.light',
                },
              }}
            >
              {t('website:homepage.loginSection.loginButton')}
            </Button>
          </LocalizedLink>
        </Box>
      </Stack>
    </Stack>
  )
}